var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeightChit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.87,
    height: 29.87,
    viewBox: "0 0 29.87 29.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-speedometer",
    "data-name": "Icon ionic-md-speedometer",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24635",
    "data-name": "Path 24635",
    d: "M9,29.25H27.381V32.7H9Z",
    transform: "translate(0.119 0.548)",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24636",
    "data-name": "Path 24636",
    d: "M18.118,20.416a2.3,2.3,0,1,0-.632-4.509L12.7,12.41l-.287.251,3.511,4.789a2.241,2.241,0,0,0-.1.668A2.3,2.3,0,0,0,18.118,20.416Z",
    transform: "translate(0.191 0.191)",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24637",
    "data-name": "Path 24637",
    d: "M18.31,3.375A14.931,14.931,0,0,0,6.541,27.5h4.222l.287-.287,1.587-1.587-1.644-1.644-1.587,1.58a11.445,11.445,0,0,1-2.527-6.1h2.24v-2.3H6.879a11.445,11.445,0,0,1,2.527-6.1l1.587,1.58,1.644-1.644-1.58-1.587a11.445,11.445,0,0,1,6.1-2.527v2.24h2.3V6.879a11.445,11.445,0,0,1,6.1,2.527l-1.58,1.587,1.644,1.644,1.587-1.58a11.445,11.445,0,0,1,2.527,6.1H27.5v2.3h2.24a11.445,11.445,0,0,1-2.527,6.1l-1.587-1.58-1.644,1.644,1.587,1.587.287.287h4.222A14.931,14.931,0,0,0,18.31,3.375Z",
    fill: "#484848"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightChit);
export default __webpack_public_path__ + "static/media/weight_chit.e66b0dd7b380def2d57e04b7f944ae2c.svg";
export { ForwardRef as ReactComponent };